import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import PropTypes from 'prop-types';
import React from 'react';
import { COLORS } from '../../../config/colors';
import HighchartsNoData from 'highcharts/modules/no-data-to-display';

Highcharts.setOptions({
  colors: [
    COLORS.PINK,
    COLORS.PURPLE,
    COLORS.BLUE,
    COLORS.ORANGE,
    COLORS.RED,
    COLORS.YELLOW
  ]
});

HighchartsNoData(Highcharts);

/**
 *
 * @param {Highcharts.Options} data
 * @param {string} title
 * @param {Highcharts.Options} options
 * @returns {Highcharts.Options}
 */
export const createPieChart = (data, title, options, chartOptions) => ({
  title: {
    text: title,
    style: {
      fontSize: '1em'
    }
  },
  series: [{
    name: '',
    data
  }],
  ...options,
  chart: {
    type: 'pie',
    inverted: true,
    height: '80%',
    ...chartOptions
  },
  noData: {
    style: {
      fontWeight: 'bold',
      fontSize: '15px',
      color: '#303030'
    }
  },
  credits: {
    enabled: false
  },
});

const Pie = ({
  data,
  title,
  options,
  chartOptions,
  containerProps,
}) => {
  const chartsOptions = createPieChart(data, title, options, chartOptions);

  return (<HighchartsReact
    className="border border-dark border-radius-1"
    highcharts={Highcharts}
    options={chartsOptions}
    containerProps={{
      className: 'border border-dark border-radius-1',
      ...containerProps,
    }}
  />);
};

Pie.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
      name: PropTypes.string,
      sliced: PropTypes.bool,
      selected: PropTypes.bool,
    })
  ).isRequired,
  title: PropTypes.string,
  options: PropTypes.object,
  chartOptions: PropTypes.object,
  containerProps: PropTypes.object,
};

Pie.defaultProps = {
  options: {},
  title: null
};
export default Pie;